var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceMaxx({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 323.85 323.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000202;\n        opacity: 0;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 322.85,
    height: 322.85
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.52,181.31h19.7l22.8,41,22.6-41h19.5v52.9h-12.8l.5-43.7h-.2l-24,43.7h-11.7l-23.9-43.7h-.2l.5,43.7h-12.8s0-52.9,0-52.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,181.31h16.2l29,52.9h-15.2l-6.8-13.1h-30.6l-6.7,13.1h-14.8l29-52.9s-.1,0-.1,0ZM145.02,212.81l-11.1-22.3-11.3,22.3h22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.62,207.01l-26.5-25.6h17l17.9,18.4,18.2-18.4h16.5l-26.6,25.6,26.6,27.3h-17.3l-17.7-19.5-17.8,19.5h-16.8l26.5-27.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.23,207.01l-26.5-25.6h17l17.9,18.4,18.2-18.4h16.5l-26.6,25.6,26.6,27.3h-17.3l-17.7-19.5-17.8,19.5h-16.8l26.5-27.3h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.66,91.48h13.09l18.16,44.58,17.77-44.58h12.63l-24.47,55.65h-12.39l-24.79-55.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.32,104.26c18.47,0,25.56,10.83,25.56,22.21s-7.09,22.21-25.56,22.21-25.56-10.83-25.56-22.21,7.09-22.21,25.56-22.21ZM127.32,140.43c10.44,0,14.34-6.78,14.34-13.95s-3.9-13.95-14.34-13.95-14.34,6.78-14.34,13.95,3.9,13.95,14.34,13.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.5,89.53h0c2.97,0,5.38,2.41,5.38,5.38h0c0,2.97-2.41,5.38-5.38,5.38h0c-2.97,0-5.38-2.41-5.38-5.38h0c0-2.97,2.41-5.38,5.38-5.38ZM160.13,105.82h10.76v41.31h-10.76v-41.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.15,120.32c-.78-4.29-5.3-7.79-11.46-7.79-9.98,0-14.34,6.78-14.34,13.95s3.9,13.95,13.17,13.95c8.34,0,10.6-3.27,12.86-9.12h11.22c-2.49,17.15-20.03,17.38-22.92,17.38-18.47,0-25.56-10.83-25.56-22.21,0-13.33,9.59-22.21,25.56-22.21,6.24,0,20.42,2.1,22.68,16.06h-11.22.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.21,129.2c.23,4.6,3.35,11.69,14.03,11.69,7.09,0,10.21-2.49,12.31-5.92h11.69c-2.34,4.6-7.95,13.72-23.69,13.72-18.63,0-25.56-10.83-25.56-21.82,0-13.8,10.21-22.6,24.86-22.6,18.32,0,25.33,11.3,25.33,23.38v1.56h-38.97ZM270.96,122.34c-1.33-8.26-8.65-10.76-13.95-10.76-4.99,0-12,2.34-13.79,10.76h27.75-.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.52,181.32h19.7l22.8,41,22.6-41h19.5v52.9h-12.8l.5-43.7h-.2l-24,43.7h-11.7l-23.9-43.7h-.2l.5,43.7h-12.8v-52.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.92,181.32h16.2l29,52.9h-15.2l-6.8-13.1h-30.6l-6.7,13.1h-14.8l29-52.9h-.11,0ZM145.02,212.82l-11.1-22.3-11.3,22.3h22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.62,207.02l-26.5-25.6h17l17.9,18.4,18.2-18.4h16.5l-26.6,25.6,26.6,27.3h-17.3l-17.7-19.5-17.8,19.5h-16.8l26.5-27.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.23,207.02l-26.5-25.6h17l17.9,18.4,18.2-18.4h16.5l-26.6,25.6,26.6,27.3h-17.3l-17.7-19.5-17.8,19.5h-16.8l26.5-27.3h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceMaxx);
export default __webpack_public_path__ + "static/media/voice-maxx.28678a0afd2ce09a045c7daea3bb004b.svg";
export { ForwardRef as ReactComponent };